import { c as _c } from "react/compiler-runtime";
import { Down } from "@icon-park/svg";
import clsx from "clsx";
import { ReactElement } from "react";
import Icon from "../Icon";
import { SelectSize } from "./types";
import styles from "./NativeSelect.module.css";
import { findSelectOptionIndex, ParsedSelectOption } from "./utils";
export interface NativeSelectProps<T> {
  id?: string;
  options: ParsedSelectOption<T>[];
  value?: T;
  onChange?: (value: T) => void;
  size?: SelectSize;
  disabled?: boolean;
  placeholder?: string;
  prefix?: ReactElement;
}
const NativeSelect = t0 => {
  const $ = _c(43);
  const {
    id,
    options,
    value,
    onChange,
    size: t1,
    disabled,
    placeholder,
    prefix
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const selectedIndex = findSelectOptionIndex(options, value);
  const hasValue = selectedIndex >= 0;
  const t2 = !disabled;
  const t3 = size === "sm";
  const t4 = size === "md";
  let t5;
  if ($[0] !== disabled || $[1] !== t2 || $[2] !== t3 || $[3] !== t4) {
    t5 = clsx("group w-full border transition-colors ease-out flex items-center justify-between bg-neutral-0 border-neutral-50 text-neutral-575", {
      "cursor-pointer hover:border-neutral-100 focus-within:border-neutral-100": t2,
      "bg-neutral-12 border-neutral-25 cursor-not-allowed": disabled,
      "text-app-body-2 py-[7px] px-3xs rounded-xs": t3,
      "text-body-2 py-[11px] px-s rounded-s": t4
    });
    $[0] = disabled;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = !hasValue && placeholder;
  let t7;
  if ($[5] !== t6) {
    t7 = clsx("flex gap-xs flex-wrap items-center flex-1 min-w-0 text-left", {
      "text-neutral-150": t6
    });
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const t8 = hasValue ? String(selectedIndex) : "";
  let t9;
  if ($[7] !== onChange || $[8] !== options) {
    t9 = event => {
      const index = Number(event.target.value);
      if (!Number.isNaN(index) && options[index]) {
        onChange?.(options[index].value);
      }
    };
    $[7] = onChange;
    $[8] = options;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const t10 = size === "sm";
  const t11 = size === "md";
  let t12;
  if ($[10] !== disabled || $[11] !== t10 || $[12] !== t11) {
    t12 = clsx(styles.select, "w-full min-w-0 bg-transparent focus:outline-none cursor-[inherit] text-inherit", {
      "text-app-body-2": t10,
      "text-body-2": t11,
      "cursor-not-allowed": disabled
    });
    $[10] = disabled;
    $[11] = t10;
    $[12] = t11;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== hasValue || $[15] !== placeholder) {
    t13 = placeholder && <option value="" disabled={hasValue}>{placeholder}</option>;
    $[14] = hasValue;
    $[15] = placeholder;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== options) {
    t14 = options.map(_temp);
    $[17] = options;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== disabled || $[20] !== id || $[21] !== t12 || $[22] !== t13 || $[23] !== t14 || $[24] !== t8 || $[25] !== t9) {
    t15 = <select id={id} disabled={disabled} value={t8} onChange={t9} className={t12}>{t13}{t14}</select>;
    $[19] = disabled;
    $[20] = id;
    $[21] = t12;
    $[22] = t13;
    $[23] = t14;
    $[24] = t8;
    $[25] = t9;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== prefix || $[28] !== t15 || $[29] !== t7) {
    t16 = <div className={t7}>{prefix}{t15}</div>;
    $[27] = prefix;
    $[28] = t15;
    $[29] = t7;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  const t17 = !disabled;
  let t18;
  if ($[31] !== disabled || $[32] !== t17) {
    t18 = clsx("ml-xs flex flex-none relative pointer-events-none", {
      "text-primary-800": t17,
      "text-neutral-150": disabled
    });
    $[31] = disabled;
    $[32] = t17;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  const t19 = size === "sm" ? 20 : 24;
  let t20;
  if ($[34] !== t19) {
    t20 = <Icon icon={Down} size={t19} className="group-focus-within:rotate-180" />;
    $[34] = t19;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== t18 || $[37] !== t20) {
    t21 = <span className={t18} aria-hidden="true">{t20}</span>;
    $[36] = t18;
    $[37] = t20;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== t16 || $[40] !== t21 || $[41] !== t5) {
    t22 = <div className={t5}>{t16}{t21}</div>;
    $[39] = t16;
    $[40] = t21;
    $[41] = t5;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  return t22;
};
export default NativeSelect;
function _temp(option, index_0) {
  return <option key={index_0} value={String(index_0)}>{option.label}</option>;
}